import { FormikHelpers } from "formik";
import Form from "../../common/Form";
import { RecuperaPasswordFormFields } from "../../config/formFields/RecuperaPassword";
import './auth.css';

const initialValues: any = {
    email_address: '',
};

export default function RecuperaPasswordPage() {
  function recuperaPasswordAction(values: any, formikHelpers: FormikHelpers<any>) {
    // console.log('form values: ', values);
    // console.log('formik helpers: ', formikHelpers);
  }

  return (
      <div id="recupera-password">
        <h1>Recupera password</h1>
        <hr />
        <Form
          id="recupera_password_form"
          className="auth-form py-4"
          formFields={RecuperaPasswordFormFields()}
          initialValues={initialValues}
          onSubmit={recuperaPasswordAction} />
      </div>
  );
}
